export default __webpack_public_path__ + "static/media/job_offer5_l.2483e7b1.jpg";